module.exports = __webpack_public_path__ + "static/media/smaller-01.83274365.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/photos/smaller-01.jpg
// module id = 111
// module chunks = 0